import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'brd-auto-log-out-dialog',
  templateUrl: './auto-log-out-dialog.component.html',
  styleUrls: ['./auto-log-out-dialog.component.scss']
})
export class AutoLogOutDialogComponent implements OnInit {
  intervalId;
  keepAliveKey: string = "keepAlive";
  public count;

  constructor(public dialogRef: MatDialogRef<AutoLogOutDialogComponent>) { }

  ngOnInit() {
    this.count = 60;
    this.intervalId = setInterval(() => {
        this.count--;
      if (localStorage.getItem(this.keepAliveKey)) {
          this.keepAlive();
        }
        if (this.count <= 0) {
          this.close(false);
        }
      },
      1000);
  }

  keepAlive(): void {
    localStorage.setItem(this.keepAliveKey, "true");
    setTimeout(() => { localStorage.removeItem(this.keepAliveKey) }, 5000);
    this.close(true);
  }

  private close(result: boolean) {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    this.dialogRef.close(result);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/components/auto-log-out-dialog.component.ts